<template>
  <div class="feature-list__one" v-if="items">
    <div class="row">
      <div v-for="(item, x) in items.data.items" :key="x" class="col-lg-6 wow move-up">
        <div class="grid-item animate">
          <div class="ht-box-icon style-01">
            <div class="icon-box-wrap">
              <div class="content">
                <h6 class="heading">{{ item.heading }}</h6>
                <div class="text" v-html="`${item.text}`"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'FeatureApp',
  computed: {
    items() {
      return this.$store.getters['app/content']('53325295-3749-4b63-878f-b4ce98cd58f3')
    }
  },
}
</script>
